<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" media="screen"
  rel="stylesheet" />
<div class="content-container shadow">
  <div class="context secondary-text-color mb-4 d-flex justify-content-end">
    <app-language-switcher [setOnLocalStorage]="false" ></app-language-switcher>
  </div>
  <div class="error-circle">
    <i class="fa fa-exclamation fa-lg"></i>
  </div>
  <div class="subheader primary-text-color">
    {{'Parece que você não está conectado à internet' | translate}}
  </div>
   {{date | i18nDate:'dd/MM/yyyy HH:mm:ss'}}
  <div class="hr"></div>
  <div class="context secondary-text-color">
    <p>{{'Por favor, confira sua rede de internet e tente novamente.' | translate}}</p>
  </div>
</div>
